import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  template: '<p-growl sticky="true"></p-growl>\n<router-outlet></router-outlet>'
})
export class AppComponent {
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/app.component.ts